// Catégorise les scènes en 3 groupes affichés sur la barre latérale droite
// des configurateurs : Façade / Angle / Intérieur.
// On s'appuie sur les conventions d'ID :
//   - "corner-*"            → Angle (pharmacies en coin de rue)
//   - "interior-*"          → Intérieur (vitrines / boutiques)
//   - tout le reste         → Façade (vues frontales d'immeubles, devantures)
export function getSceneCategory(scene) {
  if (!scene || !scene.id) return "facade";
  const id = String(scene.id);
  if (id.startsWith("corner-")) return "angle";
  if (id.startsWith("interior-")) return "interior";
  return "facade";
}

export const SCENE_CATEGORIES = [
  { key: "facade",   label: { fr: "Façade",    de: "Fassade",    en: "Facade",   it: "Facciata" } },
  { key: "angle",    label: { fr: "Angle",     de: "Eckhaus",    en: "Corner",   it: "Angolo" } },
  { key: "interior", label: { fr: "Intérieur", de: "Innenraum",  en: "Interior", it: "Interno" } },
];

export function groupScenesByCategory(scenes) {
  const groups = { facade: [], angle: [], interior: [] };
  for (const s of scenes || []) {
    const cat = getSceneCategory(s);
    groups[cat].push(s);
  }
  return groups;
}
